import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "button-go-to",
  templateUrl: "./button-go-to.component.html",
  styleUrls: ["./button-go-to.component.scss"]
})
export class ButtonGoToComponent implements OnInit {
  @Input() srcImage = "./assets/img/btt.png";

  ngOnInit() {
    this.showOrHide();
    window.onscroll = () => this.showOrHide();
  }

  showOrHide() {
    try {
      if (
        document.body.scrollTop > 400 ||
        document.documentElement.scrollTop > 400
      ) {
        document.getElementById("button-go-to").style.display = "block";
      } else {
        document.getElementById("button-go-to").style.display = "none";
      }
    } catch (e) {}
  }

  scrollToTop(scrollDuration) {
    const cosParameter = window.scrollY / 2;
    let scrollCount = 0,
      oldTimestamp = performance.now();
    function step(newTimestamp) {
      scrollCount += Math.PI / (scrollDuration / (newTimestamp - oldTimestamp));

      if (scrollCount >= Math.PI) {
        window.scrollTo(0, 0);
      }

      if (window.scrollY === 0) {
        return;
      }

      window.scrollTo(
        0,
        Math.round(cosParameter + cosParameter * Math.cos(scrollCount))
      );

      oldTimestamp = newTimestamp;
      window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }
}
